import * as apiconfig from './apiconfig';

// In-flight request deduplication: reuse same promise while a request is pending
const pendingLiveScore = { promise: null };
const pendingLeaguesBySeason = {};

const API = {
    getCountryList: () => {
        return apiconfig.apiRequest("get", `/countries`)
    }, 
    getGroupRanking: (id,season) => {
        return apiconfig.apiRequest("get", `/leagueTable/${id}/${season}`)
    },
    getMatchDetails: (id,season) => {
        return apiconfig.apiRequest("get", `/fixtures/league/${id}/${season}`)
    },
    checkUserAuth: (uid,type) => {
            return apiconfig.apiRequest("get", `/checkAccess?uid=${uid}&type=${type}&domain=${window.location.host.includes('localhost') ? 'localhost' : window.location.hostname}`,true)
    },
    checkUserAuthStaging: (uid) => {
        return apiconfig.apiRequest("get", `/checkAccessStaging?uid=${uid}&domain=${window.location.host.includes('localhost') ? 'localhost' : window.location.hostname}`, true)
    },
    getUserDetails: () => {
        return apiconfig.apiRequest("get", `/getUserProfile`,true)
    },
    editProfile: (data) => {
        return apiconfig.apiRequest("put", `/editProfile`,true,data)
    },
    deleteUser: () => {
        return apiconfig.apiRequest("delete", `/deleteUser`,true)
    },
    addPrediction: (data) => {
        return apiconfig.apiRequest("post", `/addprediction`,true,data)
    },
    getPredictions: () => {
        return apiconfig.apiRequest("get", `/predictions`,true)
    },
     getLeaders: () => {
        return apiconfig.apiRequest("get", `/leaderboard`,true)
    },
    getLiveScore: () => {
        if (pendingLiveScore.promise) return pendingLiveScore.promise;
        pendingLiveScore.promise = apiconfig.apiRequest("get", `/fixtures/live`)
            .finally(() => { pendingLiveScore.promise = null; });
        return pendingLiveScore.promise;
    },
    getNews: () => {
        return apiconfig.apiRequest("get", `/news`);
    },
    getNewsLatest: (date) => {
        const q = date ? `?date=${encodeURIComponent(date)}` : '';
        return apiconfig.apiRequest("get", `/news/latest${q}`);
    },
    getFootballNewsLeagues: () => {
        return apiconfig.apiRequest("get", `/news/leagues`);
    },
    getFootballNewsTeams: (leagueId) => {
        return apiconfig.apiRequest("get", `/news/teams?league_id=${encodeURIComponent(leagueId)}`);
    },
    getFootballNewsByLeague: (leagueId) => {
        return apiconfig.apiRequest("get", `/news/by-league?league_id=${encodeURIComponent(leagueId)}`);
    },
    getFootballNewsByTeam: (teamId) => {
        return apiconfig.apiRequest("get", `/news/by-team?team_id=${encodeURIComponent(teamId)}`);
    },
    getNewsVideos: () => {
        return apiconfig.apiRequest("get", `/news/videos`);
    },
    getLeaguesList: (season) => {
        const key = String(season);
        if (pendingLeaguesBySeason[key]) return pendingLeaguesBySeason[key];
        pendingLeaguesBySeason[key] = apiconfig.apiRequest("get", `/leagues/season/${season}`)
            .finally(() => { delete pendingLeaguesBySeason[key]; });
        return pendingLeaguesBySeason[key];
    },
    updatePredictionsPoints: (data) => {
        return apiconfig.apiRequest("post", `/updateprediction`,true,data)
    },
    getLeadersPoints: () => {
        return apiconfig.apiRequest("get", `/leaderboard`,true)
    },
    getTeamStats: (league_id,team_id,season) => {
        return apiconfig.apiRequest("get", `/statistics/${league_id}/${team_id}/${season}`)
    },
    getTeamTransfers: (team_id) => {
        return apiconfig.apiRequest("get", `/transfers/team/${team_id}`)
    },
    getTeamPlayers: (team_id,season) => {
        return apiconfig.apiRequest("get", `/players/team/${team_id}/${season}`)
    },
    getPlayersDetailsById: (player_id, teamId, leagueName, season) => {
        let url = `/players/player/${player_id}`;
        const params = [];
        if (teamId) params.push(`teamId=${encodeURIComponent(teamId)}`);
        if (leagueName) params.push(`leagueName=${encodeURIComponent(leagueName)}`);
        if (season != null) params.push(`season=${encodeURIComponent(season)}`);
        if (params.length) url += `?${params.join('&')}`;
        return apiconfig.apiRequest("get", url);
    },
    getTeamDetails: (team_id) => {
        return apiconfig.apiRequest("get", `/teams/team/${team_id}`)
    }
}


export default API;
